import endpoints from 'api/endpoints';
import { normalize } from 'normalizr';
import { story } from 'schemas';
import Immutable from 'immutable';

export default ({ requestBody }) => ({
  url: endpoints.getStoryUrl(),
  queryKey: `post${endpoints.getStoryUrl()}`,
  transform: response => normalize(response.data, story.schema).entities,
  transformResult: response => ({
    stories: normalize(response.data, story.schema).result,
  }),
  body: requestBody,
  force: true,
  meta: {
    authToken: true,
  },
  options: {
    headers: {
      Accept: 'application/json',
    },
    method: 'POST',
  },
  update: {
    story: (prevStory = Immutable.Map(), nextStory) =>
      prevStory.mergeDeep(nextStory),
  },
  updateResult: {
    stories: (prevResult = Immutable.List(), result) => prevResult.push(result),
  },
});
